module.exports = __webpack_public_path__ + "media/HeatSS.8561fd91.jpg";